import { Dispatch } from '@reduxjs/toolkit';

import SessionClientDashboard from 'dashboard/lib/clients/SessionClientDashboard';
import { User } from 'dashboard/models/user';
import { UserAuditLog } from 'dashboard/models/user-audit-log';
import { clearUserAuditLog, setUserAuditLog } from 'dashboard/redux/actions/user-audit-log';
import { ApiEndpoint } from 'lib/interfaces/api';

export function loadUserAuditLog(userAuditLogId: string) {
  return async (dispatch: Dispatch) => {
    dispatch(clearUserAuditLog());
    const { data: userAuditLog, included } = await SessionClientDashboard.getResource<UserAuditLog>(
      ApiEndpoint.UserAuditLog,
      userAuditLogId,
    );

    /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
    const user = included.find(({ id }) => id === userAuditLog.relationships.user.data.id) as User;

    dispatch(setUserAuditLog(userAuditLog, user));
  };
}
